import axios from "axios";
import {
    ElLoading,
    ElMessage
} from 'element-plus'
import {
    getRealJsonData
} from '../utils/index'
import { useDemoStore } from '@/pinia/index'
import {
    watch,
} from "vue";
import getApiUrl from './api.js'
const store = useDemoStore()
let baseURL = getApiUrl()

const service = axios.create({
    // headers: {
    //     'Content-Type': 'application/json;charset=UTF-8'
    // },
    baseURL,
    timeout: 0, // 请求超时时间(因为需要调试后台,所以设置得比较大)
    transformResponse: [function (data) {
        // 对 data 进行任意转换处理
        return getRealJsonData(data);
    }],
});
watch(() => store.server, () => {
    service.defaults.baseURL = getApiUrl()
})
// request拦截器
service.interceptors.request.use(
    (config) => {
        config.headers["Accept-Language"] = store.lang;
        config.headers["codeKey"] = store.codeKey;
        config.headers["Authorization"] = store.token
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// response 拦截器
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.Status == 0) {
            return res;
        } else if (res.Status == 401) {
            return Promise.reject(res);
        } else {
            return Promise.reject(res);
        }

    },
    (error) => {
        // ElMessage(error.msg);
        return Promise.reject(error);
    }
);
export default service;